module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal proposal-preview-modal animated fadeIn",
    class: {
      'is-active': _vm.$route.path.indexOf('/preview') > -1
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('comments-float', {
    attrs: {
      "proposal": _vm.payload
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "close-modal"
  }, [_c('i', {
    staticClass: "icon icon-close",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [(_vm.payload.status !== 'draft') ? _c('div', {
    staticClass: "sent-notice"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('proposals.already_sent')) + " "), _c('router-link', {
    attrs: {
      "to": '/a/document/' + _vm.payload.id
    }
  }, [_vm._v(_vm._s(_vm.$t('proposals.click_here')))])], 1) : _vm._e(), _vm._v(" "), (_vm.documentLoaded === false) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.documentLoaded) ? _c('document-part-cover', {
    attrs: {
      "payload": _vm.payload,
      "state": "preview"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.documentLoaded) ? _c('div', {
    staticClass: "document",
    style: ({
      'font-family': _vm.payload.options.documentFont
    })
  }, [_vm._l((_vm.payload.body), function(part, key) {
    return _c('div', {
      key: part.id
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column is-10 is-offset-1"
    }, [_c('div', {
      staticClass: "part-wrapper"
    }, [(part.type === 'h1') ? _c('document-part-h1', {
      attrs: {
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'h2') ? _c('document-part-h2', {
      attrs: {
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'h3') ? _c('document-part-h3', {
      attrs: {
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'text') ? _c('document-part-text', {
      attrs: {
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'bulleted-list') ? _c('document-part-bulleted-list', {
      attrs: {
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'numbered-list') ? _c('document-part-numbered-list', {
      attrs: {
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'image') ? _c('document-part-image', {
      attrs: {
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'table') ? _c('document-part-table', {
      attrs: {
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'module') ? _c('document-part-module', {
      attrs: {
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'pricing-table') ? _c('document-part-pricing-table', {
      attrs: {
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'page-break') ? _c('document-part-page-break', {
      attrs: {
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'initials') ? _c('document-part-initials', {
      attrs: {
        "signatures": _vm.signatures,
        "part": part,
        "state": "preview"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'signatures') ? _c('document-part-signatures', {
      attrs: {
        "signatures": _vm.payload.signatures,
        "part": part,
        "state": "preview"
      }
    }) : _vm._e()], 1)])])])
  }), _vm._v(" "), (_vm.iCanSign) ? _c('router-link', {
    staticClass: "sign-now",
    attrs: {
      "to": '/a/document-link/' + _vm.mySigningUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('proposals.sign_now')))]) : _vm._e()], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54fe2778","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/document-preview-modal.vue
// module id = 526
// module chunks = 0